import * as Api from './api';
import * as Selectors from './selectors';
import { store } from '../../../core/Store';
import { AFetchError } from '../../../core/aFetch';
import { ErrorManager, defaultErrorObject } from '@react_components/errors';
import { Actions as ConsentsActions } from './consents/reducer';
import { Actions as RisksActions } from './risks/reducer';
import * as FormManager from '../../ui/form';

export { Selectors };

export const loadAllDictionaries = (retry: number = 0) => {
	Api.getAll()
		.then((allDictionaries) => {
			// consents
			store.dispatch(
				ConsentsActions.setDictConsentsStage1(
					allDictionaries.consentsStage1
				)
			);
			store.dispatch(
				ConsentsActions.setDictConsentsStage2(
					allDictionaries.consentsStage2
				)
			);
			store.dispatch(
				FormManager.Actions.setConsentsStep1(
					allDictionaries.consentsStage1.map((el) => ({
						consentId: el.consentId,
						consentState: false,
					}))
				)
			);
			store.dispatch(
				FormManager.Actions.setConsentsStep2(
					allDictionaries.consentsStage2.map((el) => ({
						consentId: el.consentId,
						consentState: false,
					}))
				)
			);

			store.dispatch(ConsentsActions.setLoaded(true));

			// risks
			store.dispatch(
				RisksActions.setDictRisksOc(allDictionaries.risks.oc)
			);
			store.dispatch(
				RisksActions.setDictRisksKop(allDictionaries.risks.kop)
			);
			store.dispatch(
				RisksActions.setDictRisksNnw(allDictionaries.risks.nnw)
			);
			store.dispatch(
				RisksActions.setDictRisksNnwKlauzule(
					allDictionaries.risks.nnw_klauzule
				)
			);
			store.dispatch(RisksActions.setLoaded(true));
		})
		.catch((_err: AFetchError) => {
			if (retry <= 5) {
				loadAllDictionaries(retry + 1);
				return;
			}
			ErrorManager.pushError({
				...defaultErrorObject,
				title: 'Błąd podczas pobierania zasobów',
				content:
					'Aplikacja napotkała błąd podczas próby pobrania niezbędnych zasobów.',
			});
		});
};
